<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <OStringInput v-model="model" :maxlength="maxlength" :placeholder="placeholder" :disabled="normalizedDisabled"
        @change="(attrs.onChange)">
        <template v-if="slots.prefix" #prefix>
          <slot name="prefix"></slot>
        </template>
        <template v-if="slots.suffix" #suffix>
          <slot name="suffix"></slot>
        </template>
        <template v-if="slots.prepend" #prepend>
          <slot name="prepend"></slot>
        </template>
        <template v-if="slots.append" #append>
          <slot name="append"></slot>
        </template>
      </OStringInput>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormStringInputProps } from './StringInput'
import OStringInput from '../../Input/StringInput/StringInput.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormItemDisabled } from '../hooks'
import { useAttrs, useSlots } from 'vue'

defineOptions({ name: 'OFormString', inheritAttrs: false })
const slots = useSlots()
const attrs = useAttrs()

const { name, label, labelWidth, required, maxlength, placeholder } = defineProps<FormStringInputProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
